// extracted by mini-css-extract-plugin
export default {"dialogHeader":"pay_dialogHeader__1--6k","update_card":"pay_update_card__QLUGf","subscription_item":"pay_subscription_item__O274F"};